import { EWidgetResultStatus, IWidgetResultFail } from '../../types/api';

export const getResultFail = (): IWidgetResultFail => {
  return {
    status: EWidgetResultStatus.Fail,
  };
};
